var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';

function padding(s, len) {
	var len = len - (s + '').length;
	for (var i = 0; i < len; i++) {
		s = '0' + s;
	}
	return s;
};

export default {
	getQueryStringByName: function(name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
		var r = window.location.search.substr(1).match(reg);
		var context = "";
		if (r != null)
			context = r[2];
		reg = null;
		r = null;
		return context == null || context == "" || context == "undefined" ? "" : context;
	},
	FormatDate: function(date) {
		if (date == undefined || date == "") {
			return "";
		}
		var Dt = new Date(date);

		var xYear = Dt.getFullYear();
		var xMonth = Dt.getMonth() + 1;
		if (xMonth < 10) {
			xMonth = "0" + xMonth;
		}
		var xDay = Dt.getDate();
		if (xDay < 10) {
			xDay = "0" + xDay;
		}
		return xYear + "-" + xMonth + "-" + xDay;
	},
	formatDate: {


		format: function(date, pattern) {
			pattern = pattern || DEFAULT_PATTERN;
			return pattern.replace(SIGN_REGEXP, function($0) {
				switch ($0.charAt(0)) {
					case 'y':
						return padding(date.getFullYear(), $0.length);
					case 'M':
						return padding(date.getMonth() + 1, $0.length);
					case 'd':
						return padding(date.getDate(), $0.length);
					case 'w':
						return date.getDay() + 1;
					case 'h':
						return padding(date.getHours(), $0.length);
					case 'm':
						return padding(date.getMinutes(), $0.length);
					case 's':
						return padding(date.getSeconds(), $0.length);
				}
			});
		},
		parse: function(dateString, pattern) {
			var matchs1 = pattern.match(SIGN_REGEXP);
			var matchs2 = dateString.match(/(\d)+/g);
			if (matchs1.length == matchs2.length) {
				var _date = new Date(1970, 0, 1);
				for (var i = 0; i < matchs1.length; i++) {
					var _int = parseInt(matchs2[i]);
					var sign = matchs1[i];
					switch (sign.charAt(0)) {
						case 'y':
							_date.setFullYear(_int);
							break;
						case 'M':
							_date.setMonth(_int - 1);
							break;
						case 'd':
							_date.setDate(_int);
							break;
						case 'h':
							_date.setHours(_int);
							break;
						case 'm':
							_date.setMinutes(_int);
							break;
						case 's':
							_date.setSeconds(_int);
							break;
					}
				}
				return _date;
			}
			return null;
		}

	},
	//特殊符号验证
	isExistsSymbol: function(value) {
		//除了“_”以外的所有符号都参与验证
		var reg = "!@#$^&*()=|{}':;',\\[\\].<>/?\~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+-[]\"《》\·\`";
		for (var i = 0; i < value.length; i++) {
			if (reg.indexOf(value[i]) >= 0) {
				return true;
			}
		}
		return false;
	},
	getLocalTime: function() {
		var oDay = new Date();
		// oDay.getYear(); //当前年份
		// oDay.getFullYear(); //完整的年月日（xx年，xx月，xx日）
		// oDay.getMonth(); //当前的月份(0-11,0代表1月)         // 获取当前的月份是oDay.getMonth()+1;   <br>oDay.getDate(); //当前的日(1-31) 
		// oDay.getDay(); //当前的星期X(0-6,0代表星期天) 
		// oDay.getTime(); //当前的时间(从1970.1.1开始的毫秒数) 
		// oDay.getHours(); //当前的小时数(0-23) 
		// oDay.getMinutes(); //当前的分钟数(0-59) 
		// oDay.getSeconds(); //当前的秒数(0-59) 
		// oDay.getMilliseconds(); //当前的毫秒数(0-999) 
		// oDay.toLocaleDateString(); //当前的日期 
		return oDay.getHours() + ":" + oDay.getMinutes() + ":" + oDay.getSeconds();
	},
	FromatterBr: function(value) {
		if (value != '' & value != undefined & value != null) {
			return value.replace(new RegExp("<br/>", "gm"), "\r\n");
		}
	},
	//获取日期 指定正数为前几天或者传值空为本月第一天
	getDate(days) {
		if (days == undefined || days == null || days == '') {
			days = 0;
		}
		const nowDate = new Date();
		nowDate.setDate(nowDate.getDate() + days);

		const date = {
			year: nowDate.getFullYear(),
			month: nowDate.getMonth() + 1,
			date: nowDate.getDate(),
		}
		const newmonth = date.month > 9 ? date.month : '0' + date.month
		const day = date.date > 9 ? date.date : '0' + date.date
		return date.year + '-' + newmonth + '-' + day
	},
	//对象深复制
	ObjectCopy: function(obj) {
		return JSON.parse(JSON.stringify(obj));
	},
	getPageId: function() {
		return "Page_" + Date.parse(new Date());
	},
	// Excel导入-限制上传附件类型
	beforeExcelImport(file) {
		// 后缀获取
		var suffix = '';
		try {
			var flieArr = file.name.split('.');
			suffix = flieArr[flieArr.length - 1];
		} catch (err) {
			suffix = '';
		}
		if (!suffix) {
			isfile = false;
			this.$message.error('文件格式错误!');
		}
		var isfile = true;
		if (suffix != 'xls' && suffix != 'xlsx') {
			isfile = false;
			this.$message.error('上传文件只能是Excel格式!');
		}
		return isfile;
	},
};


// WEBPACK FOOTER //
// ./src/common/js/util.js